import send from "../../util/request";

export function reconciliation(params = {}) {
  return send({ url: '/ipp/reconciliation/select', method: 'POST', data: params, options: { loading: true } });
}

export function updateReconciliation(params = {}) {
  return send({ url: '/ipp/reconciliation/update', method: 'POST', data: params, options: { loading: true } });
}

export function confirmReconciliation(params = {}) {
  return send({ url: '/ipp/reconciliation/confirm', method: 'POST', data: params, options: { loading: true } });
}

export function reconciliationDetail(params = {}) {
  return send({ url: '/ipp/reconciliation/detail', method: 'POST', data: params, options: { loading: true } });
}

// 自动确认对账单-保存
export function orderPurchaseSaveBillConfig(params = {}) {
  return send({ url: '/ipp/order-purchase/save-bill-config', method: 'POST', data: params, options: { loading: true } });
}

// 自动确认对账单-详情
export function orderPurchaseBillConfig(params = {}) {
  return send({ url: '/ipp/order-purchase/bill-config', method: 'POST', data: params, options: { loading: true } });
}